type ReorderErrorProps = {
  message: string | null;
};

export function ReorderError({ message }: ReorderErrorProps) {
  return message ? (
    <p className="mb-3 text-sm text-destructive" role="alert">
      {message}
    </p>
  ) : null;
}
